import React, { ReactElement } from 'react';
import { Typography } from '@guildeducationinc/recess';
import { Skeleton } from 'src/components/UserFacetSkeletonLoader';
import { HighlightPopover } from '../HighlightPopover';
import styles from './Highlight.module.scss';

interface Props {
	body: string | ReactElement;
	dpp?: boolean;
	label: string;
	loading: boolean;
	popoverContent: string;
}

export const Highlight: React.FC<Props> = ({ body, dpp, label, loading, popoverContent }) => {
	const HighlightBody: React.FC = () => {
		const popoverLabel = `More info about program ${label.toLocaleLowerCase()}`;
		return (
			<div className={styles.popoverWrapper}>
				<Typography variant='body1'>{body}</Typography>
				<HighlightPopover
					eventText={`${label}: ${body}`}
					id={label}
					popoverContent={popoverContent}
					popoverLabel={popoverLabel}
				/>
			</div>
		);
	};

	return (
		<Skeleton dataLoading={loading} height={48} style={{ margin: '8px 0' }} width={300}>
			<div
				className={dpp ? styles.highlightDpp : styles.highlight}
				data-testid={`highlight-${label}`}
			>
				<Typography className={styles.label} variant='label1'>
					{label}
				</Typography>

				{dpp ? (
					<div className={styles.dpp}>
						<Typography variant='body1'>Direct Payment Program</Typography>
						<HighlightBody />
					</div>
				) : (
					<HighlightBody />
				)}
			</div>
		</Skeleton>
	);
};
